import { render, staticRenderFns } from "./EventsDayPage.vue?vue&type=template&id=6a9b10c2"
import script from "./EventsDayPage.vue?vue&type=script&lang=js"
export * from "./EventsDayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports